export default __webpack_public_path__ + "static/media/produkt-grafiken-all-products-white.9d75d8df.jpg";